/**
 * H2C Backend
 * An ASP.NET Core Web API for managing H2C User 
 *
 * The version of the OpenAPI document: V40:2026_08_27_13_13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { TCreateDokumentDTO } from '../model/models';
import { TDokumentDTO } from '../model/models';
import { TPostDokumentDTO } from '../model/models';
import { TPutDokumentDTO } from '../model/models';
import { TUserDTO } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface DocumentServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param companyId 
     * @param documentTypeId 
     */
    apiDokumenteDocumentCompanyIdDocumentTypeIdGet(companyId: number, documentTypeId: number, extraHttpRequestParams?: any): Observable<TDokumentDTO>;

    /**
     * 
     * 
     * @param documentTypeId 
     */
    apiDokumenteDocumentDocumentTypeIdDelete(documentTypeId: number, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param documentTypeId 
     */
    apiDokumenteDocumentDocumentTypeIdGet(documentTypeId: number, extraHttpRequestParams?: any): Observable<TDokumentDTO>;

    /**
     * 
     * 
     * @param documentTypeId 
     * @param tCreateDokumentDTO 
     */
    apiDokumenteDocumentDocumentTypeIdPut(documentTypeId: number, tCreateDokumentDTO?: TCreateDokumentDTO, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * 
     * 
     * @param tPostDokumentDTO 
     */
    apiDokumenteDocumentPost(tPostDokumentDTO?: TPostDokumentDTO, extraHttpRequestParams?: any): Observable<TUserDTO>;

    /**
     * 
     * 
     * @param tPutDokumentDTO 
     */
    apiDokumenteDocumentPut(tPutDokumentDTO?: TPutDokumentDTO, extraHttpRequestParams?: any): Observable<TUserDTO>;

}
